import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

export async function getRotasEntrega(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetRotasDeEntrega(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function salvarRotaEntrega(rota, tp_id) {
  try {
    const response = await authHttp().post(routes.urlGetRotasDeEntrega(tp_id), rota)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function exportarClientesRotasEntrega(tp_id) {
  try {
    window.open(routes.urlExportarClientesRotasEntrega(tp_id), '_blank')
  } catch (error) {
    throw errorHandler(error)
  }
}
